import { createContext } from "react";
import type { CheckboxGroupState } from "react-stately";

export const CheckboxGroupContext = createContext<CheckboxGroupState>({} as CheckboxGroupState);
